<template>
  <div
    class="relative h-20"
    :class="{ '!h-12': !hasErrors}"
  >
    <div
      v-if="icon"
      class="ml-3 absolute h-12 flex place-items-center place-content-center"
    >
      <img
        :src="icon"
        class="h-5 w-5"
      >
    </div>
    <button
      id="dropdownMenuButton"
      :class="{'pl-11': icon}"
      class="ring-1 ring-[#CFCFCF] rounded h-12 px-5 w-full font-source-sans-pro focus:outline-none focus-within:bg-[#e8f0fe] hover:ring-gray group-hover:bg-[#e8f0fe] group-disabled:bg-semigray disabled:bg-semigray
        flex justify-start items-center group"
      type="button"
      @click="show()"
    >
      <p v-if="selectedMonth.length == 0">
        Hónap
      </p>
      <p v-else>
        {{ selectedYear }} - {{ months[selectedMonth-1].long }}
      </p>
      <img
        src="/img/icons/inputs/dropdown_arrow_icon.svg"
        class="h-[16px] w-[16px] ml-auto transform transition-all group-hover:text-gray-darkest duration-500 "
        :class="{ 'rotate-180': hasFocus}"
      >
    </button>
    <div
      v-if="hasErrors"
      :class="{ '!h-[32px]': validationErrors }"
      class="w-4 font-source-sans-pro text-sm text-red transition-all h-[0px] duration-1000"
    >
      {{ validationErrors ? validationErrors[0] : "" }}
    </div>
    <div
      :class="{ 
        'ring-[#CFCFCF] max-h-[600px] p-5': hasFocus,
        'ring-transparent max-h-[0px] px-5 pb-0': !hasFocus
      }"
      class="z-50 absolute top-14 ring-1 bg-white rounded font-source-sans-pro
      transition-height duration-500 overflow-y-auto
      flex flex-col w-[90vw] mx-auto md:w-full md:min-w-[500px] !overflow-hidden
      "
    >
      <div class="w-full">
        <div
          class="w-full flex flex-col justify-center"
        >
          <div class="w-full flex flex-row place-items-center">
            <div class="w-1/12">
              <img
                src="/img/icons/inputs/golden_arrow_icon.svg"
                class="h-[15px] w-[8px] transform rotate-180 cursor-pointer mx-auto" 
                @click="previousYear()"
              >
            </div>
            <div class="w-10/12 text-center text-lg font-semibold font-source-serif-pro">
              <h4>{{ selectedYear }}</h4>
            </div>
            <div class="w-1/12">
              <img
                src="/img/icons/inputs/golden_arrow_icon.svg"
                class="h-[15px] w-[8px] cursor-pointer mx-auto" 
                @click="nextYear()"
              >
            </div>
          </div>
          <div class="grid grid-cols-3 grid-rows-4 gap-3 mt-3">
            <div
              v-for="(item, index) in months"
              :key="index"
              :class="{ selected: selectedMonth == index }"
              class="text-center min-h-[30px] max-h-[30px] w-full cursor-pointer pointer-events-auto flex place-items-center place-content-center"
              @click="selectMonth(index)"
            >
              {{ item.long }}
            </div>
          </div>
        </div>
      </div>
      <div class="w-full flex items-center place-content-center gap-3 mt-3">
        <button
          type="button"
          class="btn btn-red w-2/4"
          @click="clickCloseButton()"
        >
          Ok
        </button>
        <!-- <button
          type="button"
          class="btn btn-yellow w-1/4"
          @click="clickDeleteButton()"
        >
          Törlés
        </button> -->
      </div>
    </div>
  </div>
</template>
<script>
import { DateTime } from "luxon";

export default {
  props: {
    value: {
      type: String,
      default: null
    },
    validationErrors: {
      type: Array,
      default: () => {
        return [];
      }
    },
    icon: {
      type: String,
      default: ""
    },
    hasErrors: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {
      hasFocus: false,
      hasFocus2: false,
      visible2: false,
      hover: "",
      today: new Date(),
      years: [
        {
          value: 2019,
          label: "2019"
        },
        {
          value: 2020,
          label: "2020"
        },
        {
          value: 2021,
          label: "2021"
        },
        {
          value: 2022,
          label: "2022"
        },
        {
          value: 2023,
          label: "2023"
        }
      ],
      days: [
        { id: 1, sort: "h", long: "hétfő" },
        { id: 2, sort: "k", long: "kedd" },
        { id: 3, sort: "sz", long: "szerda" },
        { id: 4, sort: "cs", long: "csütörtök" },
        { id: 5, sort: "p", long: "péntek" },
        { id: 6, sort: "sz", long: "szombat" },
        { id: 7, sort: "v", long: "vasárnap" }
      ],
      months: [
        { id: "01", sort: "jan", long: "január" },
        { id: "02", sort: "feb", long: "február" },
        { id: "03", sort: "már", long: "március" },
        { id: "04", sort: "ápr", long: "április" },
        { id: "05", sort: "máj", long: "május" },
        { id: "06", sort: "jún", long: "június" },
        { id: "07", sort: "júl", long: "július" },
        { id: "08", sort: "aug", long: "augusztus" },
        { id: "09", sort: "szep", long: "szeptember" },
        { id: "10", sort: "okt", long: "október" },
        { id: "11", sort: "nov", long: "november" },
        { id: "12", sort: "dec", long: "december" }
      ],
      selectedYear: 2019,
      selectedMonth: ""
    };
  },
  computed: {
    // a computed getter
    currentMonth() {
      // `this` points to the vm instance
      return this.today.getMonth();
    },
    currentYear() {
      // `this` points to the vm instance
      return this.today.getFullYear();
    }
  },
  watch: {
    value() {
      if (this.value) {
        console.log('remonthpicker value',this.value)
        this.selectedMonth = DateTime.fromISO(this.value).month;
        this.selectedYear = DateTime.fromISO(this.value).year;
        console.log('remonthpicker value watch', this.selectedMonth, this.selectedYear)
      }
    }
  },
  created() {
    if (process.browser) {
      // window.addEventListener("click", this.close);
    }
  },

  beforeDestroy() {
    if (process.browser) {
      // window.removeEventListener("click", this.close);
    }
  },
  beforeMount() {
    if (this.value) {
      this.selectedMonth = DateTime.fromISO(this.value).month;
      this.selectedYear = DateTime.fromISO(this.value).year;
      console.log('remonthpicker value beforemount', this.selectedMonth)
    }
  },
  methods: {
    clickCloseButton() {
      const value =
        "" +
        this.selectedYear +
        "-" +
        this.months[this.selectedMonth-1].id +
        "-01";
      this.$emit("input", value);
      this.hasFocus = false;
    },
    previousYear() {
      this.selectedYear = this.selectedYear - 1;
      const value =
        "" +
        this.selectedYear +
        "-" +
        this.months[this.selectedMonth-1].id +
        "-01";
      this.$emit("input", value);
    },
    nextYear() {
      this.selectedYear = this.selectedYear + 1;
      const value =
        "" +
        this.selectedYear +
        "-" +
        this.months[this.selectedMonth-1].id +
        "-01";
      this.$emit("input", value);
    },
    selectMonth(index) {
      this.selectedMonth = index+1;
      const value =
        "" +
        this.selectedYear +
        "-" +
        this.months[this.selectedMonth-1].id +
        "-01";
        console.log('selectmonth', this.selectedMonth, value)
      this.$emit("input", value);
      this.hasFocus = false;
    },
    close(e) {
      if (!this.$el.contains(e.target)) {
        this.hasFocus = false;
      }
    },
    show() {
      if (this.value.length === 0) {
        this.selectedMonth = this.currentMonth;
        this.selectedYear = this.currentYear;
      }
      this.hasFocus = !this.hasFocus;
      this.$nextTick(() => {});
    }
  }
};
</script>